import React, { useEffect, useState } from "react";
import { Get } from "../../Axios/AxiosFunctions";
import { BaseURL } from "../../config/apiUrl";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import DesktopFooter from "./DesktopFooter";

function Footer({ containerClass }) {
  const [isMobile, setIsMobile] = useState(false);
  const [links, setLinks] = useState([]);

  //   get links
  const getLinks = async () => {
    const response = await Get(BaseURL("links"));
    if (response !== undefined) setLinks(response?.data?.data);
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
    getLinks();
  }, []);
  // return isMobile ? <></> : <DesktopFooter
  return <DesktopFooter containerClass={containerClass} links={links} />;
}

export default Footer;
